<template>
  <!-- :class="{'flex_box_Vertical':viewData.flex=='2','flex_box_Horizontal':viewData.flex=='1',}" -->
  <div
    class="flex_box"
    :style="Object.assign({}, styleMerge, inputCSS)"
  >
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
    </div>
    <div :style="Object.assign({}, styleMerge, inputCSS)">
      <span
        v-if="!viewData.defaultVal"
        class="placeholder"
      >
        {{ viewData.placeholder || '请输入提示内容' }}
      </span>
      <span
        v-if="viewData.defaultVal"
        class="value"
      >
        {{ viewData.defaultVal }}
      </span>
    </div>
    <!-- <el-input
      v-model="viewData.defaultVal"
      :placeholder="viewData.placeholder"
    />     -->
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
import { CSSTransition } from '@/view/weappTmp/core/lib/public/css.js'
const inputCSSMap = {
  'inputItemBorderColor': (arg) => {
    return { key: 'border', value: `1px solid ${arg}` }
  },
  'inputItemBottomLineColor': (arg) => {
    return { key: 'border-bottom', value: `1px solid ${arg}` }
  },
  'inputBackgroundColor': 'background-color'
}
export default {
  name: 'SpInput',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      inputVal: null,
      viewData: {
        margin: [0, 0, 0, 0]
      },
      CSSSouce: {},
      inputCSS: {}
    }
  },
  watch: {
    CSSSouce: {
      handler (nv) {
        console.log('SPinput CSSSouce', nv)

        this.inputStyleMergeHandle()
      },
      deep: true
    }
  },
  mounted () {},
  methods: {
    // console.log('spinput-viewData',this.viewData)
    inputStyleMergeHandle () {
      // const inputStyleMergeHandleCss = CSSTransition(this.CSSSouce,inputCSSMap)
      for(let i in this.CSSSouce.inputStyle){
        this.CSSSouce[i] = this.CSSSouce.inputStyle[i]
      }
      this.inputCSS = CSSTransition(this.CSSSouce, inputCSSMap)
      // console.log('input-CSSTransition',inputStyleMergeHandleCss)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  border: none !important;
  background: none !important;
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
